import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import OrderDetails from "./OrderDetails";
import OrdersList from "./OrdersList";
import { getOrder } from "../../util/ApiService";
import { LanguageContext } from "../../context/LanguageContext";

const OrdersPage = () => {
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const user = JSON.parse(localStorage.getItem("users"));
  const { currentLang: selectedLanguage } = useContext(LanguageContext);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setLoading(true);
        const response = await getOrder(selectedLanguage, user?.email);
        setOrders(response.data || []);
      } catch (err) {
        setError("Failed to load orders.");
        console.error("Orders API error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  const handleBack = () => {
    setSelectedOrder(null);
  };

  const handleSelectOrder = (order) => {
    setSelectedOrder(order);
  };

  return (
    <div className="orders-page">
      {loading && <p>Loading orders...</p>}
      {error && <p className="error">{error}</p>}

      {!loading &&
        !error &&
        (selectedOrder ? (
          <OrderDetails order={selectedOrder} onBack={handleBack} />
        ) : (
          <OrdersList orders={orders} onSelectOrder={handleSelectOrder} />
        ))}
    </div>
  );
};

export default OrdersPage;
